// extracted by mini-css-extract-plugin
export default {"swither":"LocalSwitcher_swither_DrmAI","select":"LocalSwitcher_select_IA7FB","option":"LocalSwitcher_option_O1R8P"};